import { Nullable } from '@/models/Model';
import Resource from '@/models/Resource';

export const getResourceUrl = (resource: Resource): Nullable<string> => {
  if (resource.resourceLink) return resource.resourceLink;
  if (typeof resource.resourceFile === 'string') return resource.resourceFile;
  return null;
};
